import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { LicenseType } from './gqty/schema.generated';
import { LicenseService } from './license.service';

/**
 * `canMatch` guard for a route gated behind a module license. Returns true when
 * the module is active; otherwise false, so the router falls through to a
 * sibling route (typically the gated upsell page).
 */
export function moduleLicensed(module: LicenseType): CanMatchFn {
  return async () => {
    const licenses = inject(LicenseService);
    await licenses.load();
    return licenses.hasModule(module);
  };
}
